var _style, _g, _g2, _g3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMissingFields(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 776.7 488.2",
    style: {
      enableBackground: "new 0 0 776.7 488.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C53F3F;}\n\t.st1{opacity:0.8;fill:#FFFFFF;enable-background:new    ;}\n\t.st2{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\n\t.st3{fill:#B8B8B8;}\n\t.st4{fill:none;stroke:#263238;stroke-width:1.0474;stroke-miterlimit:10;}\n\t.st5{opacity:0.3;enable-background:new    ;}\n\t.st6{fill:#FFFFFF;stroke:#263238;stroke-width:1.0474;stroke-linecap:round;stroke-linejoin:round;}\n\t.st7{fill:#263238;stroke:#263238;stroke-width:1.0474;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{fill:#C53F3F;stroke:#263238;stroke-width:1.0474;stroke-linecap:round;stroke-linejoin:round;}\n\t.st9{fill:#737373;stroke:#263238;stroke-width:1.0474;stroke-linecap:round;stroke-linejoin:round;}\n\t.st10{fill:none;stroke:#263238;stroke-width:1.0474;stroke-linecap:round;stroke-linejoin:round;}\n\t.st11{fill:none;stroke:#FFFFFF;stroke-width:1.0474;stroke-linecap:round;stroke-linejoin:round;}\n\t.st12{fill:none;stroke:#263238;stroke-width:3.1423;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.2,357.4c0,0,38.3,87.4,135.3,116s200.5-9.5,285-38.1s129.1-101.8,110.2-176.9S565.7,188.6,499.2,122 s-74-94.5-166.1-114.2S140.1,65.6,114.9,175.4S125.2,357.4,125.2,357.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.2,357.4c0,0,38.3,87.4,135.3,116s200.5-9.5,285-38.1s129.1-101.8,110.2-176.9S565.7,188.6,499.2,122 s-74-94.5-166.1-114.2S140.1,65.6,114.9,175.4S125.2,357.4,125.2,357.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M617.7,239.2c0,0,35.1,3.5,53,25.3c0,0,18.8-25.2,52.6-24.7c24.1-29,20.1-72.1-9-96.2 c-29-24.1-72.1-20.1-96.2,9C597.2,177.7,597.1,214,617.7,239.2L617.7,239.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M617.7,239.2c0,0,35.1,3.5,53,25.3c0,0,18.8-25.2,52.6-24.7c24.1-29,20.1-72.1-9-96.2 c-29-24.1-72.1-20.1-96.2,9C597.2,177.7,597.1,214,617.7,239.2L617.7,239.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "669.4,132.7 668.2,360.4 674.2,360.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M671.2,257.8c0,0,11.9-21.4,33.2-27.9c0,0-22.5,5.4-33.7,23.7L671.2,257.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M671.2,197.3c0,0,11.9-21.4,33.2-27.9c0,0-22.5,5.3-33.7,23.7L671.2,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M671.2,227.6c0,0,11.9-21.4,33.2-27.9c0,0-22.5,5.4-33.7,23.7L671.2,227.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M669.5,212.7c0,0-11.5-21.3-32.1-27.9c0,0,21.8,5.3,32.6,23.7L669.5,212.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M669.5,242.4c0,0-11.5-21.4-32.1-27.9c0,0,21.8,5.3,32.6,23.7L669.5,242.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.4,239.2c0,0,35.1,3.5,53,25.3c0,0,18.8-25.2,52.6-24.7c24.1-29,20.1-72.1-9-96.2 c-29-24.1-72.1-20.1-96.2,9C21.9,177.7,21.8,214,42.4,239.2L42.4,239.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.4,239.2c0,0,35.1,3.5,53,25.3c0,0,18.8-25.2,52.6-24.7c24.1-29,20.1-72.1-9-96.2 c-29-24.1-72.1-20.1-96.2,9C21.9,177.7,21.8,214,42.4,239.2L42.4,239.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "94.2,132.7 93,360.4 98.9,360.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96,257.8c0,0,11.9-21.4,33.2-27.9c0,0-22.5,5.4-33.7,23.7L96,257.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96,197.3c0,0,11.9-21.4,33.2-27.9c0,0-22.5,5.3-33.7,23.7L96,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96,227.6c0,0,11.9-21.4,33.2-27.9c0,0-22.5,5.4-33.7,23.7L96,227.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M94.2,212.7c0,0-11.5-21.3-32.1-27.9c0,0,21.8,5.3,32.6,23.7L94.2,212.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M94.2,242.4c0,0-11.5-21.4-32.1-27.9c0,0,21.8,5.3,32.6,23.7L94.2,242.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M474.8,261.3c0,0,28.8,2.8,43.3,20.7c0,0,15.4-20.7,43.1-20.2c19.7-23.8,16.4-59-7.4-78.7 c-23.8-19.7-59-16.4-78.7,7.4C458.1,210.9,458,240.6,474.8,261.3L474.8,261.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M474.8,261.3c0,0,28.8,2.8,43.3,20.7c0,0,15.4-20.7,43.1-20.2c19.7-23.8,16.4-59-7.4-78.7 c-23.8-19.7-59-16.4-78.7,7.4C458.1,210.9,458,240.6,474.8,261.3L474.8,261.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "517.2,174 516.3,360.4 521.1,360.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M518.7,276.5c0,0,9.7-17.5,27.2-22.8c0,0-18.4,4.4-27.6,19.4L518.7,276.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M518.7,226.9c0,0,9.7-17.5,27.2-22.8c0,0-18.4,4.4-27.6,19.4L518.7,226.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M518.7,251.7c0,0,9.7-17.5,27.2-22.8c0,0-18.4,4.4-27.6,19.4L518.7,251.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M517.2,239.6c0,0-9.4-17.5-26.2-22.8c0,0,17.8,4.4,26.7,19.4L517.2,239.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M517.2,263.8c0,0-9.4-17.5-26.2-22.8c0,0,17.8,4.4,26.7,19.4L517.2,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.5,261.3c0,0,28.8,2.8,43.3,20.7c0,0,15.3-20.7,43.1-20.2c19.7-23.8,16.4-59-7.4-78.7s-59-16.4-78.7,7.4 C179.8,210.9,179.6,240.6,196.5,261.3L196.5,261.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M196.5,261.3c0,0,28.8,2.8,43.3,20.7c0,0,15.3-20.7,43.1-20.2c19.7-23.8,16.4-59-7.4-78.7s-59-16.4-78.7,7.4 C179.8,210.9,179.6,240.6,196.5,261.3L196.5,261.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "238.9,174 237.9,360.4 242.8,360.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M240.4,276.5c0,0,9.7-17.5,27.2-22.8c0,0-18.4,4.4-27.6,19.4L240.4,276.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M240.4,226.9c0,0,9.7-17.5,27.2-22.8c0,0-18.4,4.4-27.6,19.4L240.4,226.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M240.4,251.7c0,0,9.7-17.5,27.2-22.8c0,0-18.4,4.4-27.6,19.4L240.4,251.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M238.9,239.6c0,0-9.4-17.5-26.2-22.7c0,0,17.8,4.4,26.7,19.4L238.9,239.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M238.9,263.8c0,0-9.4-17.5-26.2-22.8c0,0,17.8,4.4,26.7,19.4L238.9,263.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 53,
    y1: 361.3,
    x2: 714.7,
    y2: 361.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-123"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M233.6,435.3c0,4.6-28.3,8.3-63.2,8.3s-63.2-3.7-63.2-8.3s28.3-8.3,63.2-8.3S233.6,430.7,233.6,435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M365.8,435.3c0,4.6-28.3,8.3-63.2,8.3s-63.2-3.7-63.2-8.3s28.3-8.3,63.2-8.3S365.8,430.7,365.8,435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M541,435.3c0,4.6-28.3,8.3-63.1,8.3s-63.2-3.7-63.2-8.3s28.3-8.3,63.2-8.3S541,430.7,541,435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M687.3,435.3c0,4.6-28.3,8.3-63.2,8.3s-63.2-3.7-63.2-8.3s28.3-8.3,63.2-8.3 C658.9,427,687.3,430.7,687.3,435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M484.7,193.5c0,0-2.6,10.7-2.6,12.5c0,1.1-0.1,2.2-0.4,3.3c0,0-5.5,6.6-4.8,8.5c0.9,1.4,2.2,2.6,3.7,3.3 c0,0,2.9,10.7,5.9,11.4c3,0.6,6.1,0.9,9.2,1.1l1.1,8.8l14.8-2.2l-3.7-13.3l1.5-11.4c0,0,2.6-4.8,0-12.5c-2.6-7.7-8.1-8.1-11.8-8.1 C493.3,194.7,488.9,194.2,484.7,193.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M491.3,187.9c0,0-12.9-0.4-12.5,2.9c0.4,3.3,13.6,7.7,13.6,7.7s-4.4,2.9-2.2,5.9c2.2,3,7.4,5.5,7.4,5.5 s-1.5,6.3,0.8,6.6c2.3,0.4,3.7-3,4-4.1c0.4-1.1,4.4-0.7,5.5,2.2c0.6,1.5,1,3.2,1.1,4.8c0,0,4.4-13.3,5.2-19.2 S498.3,187.9,491.3,187.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M499.5,216.8c0,0,4.5-9.8,7.1-5c2.7,4.8,1.5,9.9-1.1,10.4c-2.6,0.5-4.8,1.1-4.8,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M481.3,319.2c-0.7,0.8-12.5,26.2-14,34.7c-1.5,8.5-11.1,59-11.4,61.2c-0.4,2.2-20.6,6.6-22.1,7 c-1.5,0.4,1.5,4.4,5.9,5.5c4.4,1.1,17,6.3,19.9,3.3c3-3,7-19.6,8.1-21.4c1.1-1.8,21.9-50.8,21.9-50.8s10.6-23.5,12.9-25.7 c2.2-2.2-2.6-12.1-4.5-15C496.1,315.2,486.5,313.3,481.3,319.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M479.1,319.6c0,0,5.2,24.7,7.7,33.6c2.4,7.4,6,14.4,10.7,20.7c3,4.1,17.3,39.9,17.3,39.9l2.2,5.5 c0,0-0.7,2.2-4.8,5.2c-4,2.9-15.5,7.7-12.5,8.9c3,1.1,14.8,1.1,20.3,0.7c4.8-0.3,9.2-2.4,12.5-5.9c2.2-2.6-3.7-10-3.7-11.4 s-12.9-46.5-13.6-48.7s-4.4-18.1-4.4-18.1v-18c0,0,1.9-3.3,1.9-10.7s-5.5-8.9-5.5-8.9l-30.3,3L479.1,319.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M476.6,317.4c0,0,0.8,6.3,3,6.6c2.2,0.4,25.1,6.6,35-0.7c0,0,1.8-5.5,0.7-7c-1.1-1.5-3.7-0.7-17-0.7 C485.1,315.6,476.6,315.6,476.6,317.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M510.5,234.8c0,0-13.6,1.8-19.6,7.7c-5.9,5.8-11.1,16.6-13.6,26.6c-2.6,10-4.4,46.5-0.8,48.3 c3.7,1.8,34.7,3.7,39.9,1.5c5.2-2.2-0.4-19.6-0.4-26.2c0-6.6,5.9-29.1,4.8-41.7C519.7,238.5,510.5,234.8,510.5,234.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M461.2,273.1c-0.2-15.2-6.4-28.1-14.6-33.7v-3.1l-22.7,0.2c-12.8,0.1-23,16.9-22.7,37.3 c0.3,20.4,10.7,36.9,23.5,36.8l22.7-0.2v-3.1C455.4,301.4,461.3,288.3,461.2,273.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M471.4,273c-0.2-15.9-6.3-29.6-15-35.5v-3.3l-9.7,0.1c-13.4,0.1-24.1,17.7-23.9,39.2s11.3,38.8,24.7,38.6 l9.7-0.1v-3.3C465.7,302.7,471.6,288.9,471.4,273z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M481.2,272.9c0.2,21.5-10.5,39-23.9,39.2c-13.4,0.1-24.5-17.2-24.7-38.6s10.5-39,23.9-39.2 C469.9,234.1,480.9,251.4,481.2,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M475.6,272.2c0.1,10.2-5,18.5-11.3,18.6s-11.6-8.1-11.7-18.4s5-18.4,11.3-18.6 C470.2,253.7,475.5,262.1,475.6,272.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M656.3,348.7c1.3-9.5,1.8-19,1.6-28.5c-5,2.3-34.1,3.1-36.7,3.2c-2.7,0.1-31.7-0.9-36.7-3.2 c-0.2,9.5,0.3,19.1,1.5,28.5c2,12.4,19.7,62.2,20.1,64.6c0.5,2.3,1.2,4.6,2,6.8c0,0-10,7.2-14.5,10s-1.2,4,3.2,4 c4.4,0,13.6-1.2,16.5-1.2c2.5,0,6.8-2.2,7.8-2.7c1,0.5,5.3,2.7,7.8,2.7c2.8,0,12.1,1.2,16.5,1.2c4.4,0,7.7-1.2,3.2-4 s-14.5-10-14.5-10c0.8-2.2,1.5-4.5,2-6.8C636.6,410.9,654.3,361.1,656.3,348.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M615.1,242.1c0,0-15.5,5.1-23.6,10.2c-8,5.1-16.1,32.7-16.1,33.7c-0.5,1.9-1.1,3.8-1.9,5.6c0,0-8-1.9-9.6,4.8 c-1.6,6.7,8,15.3,13.1,15.5s6.7-1.3,6.7-1.3s-3.2,6.4-1.9,9.1c1.3,2.7,12.6,12.6,34.8,12.3c22.2-0.3,38.3-4,40.7-7.2 c2.3-3.2,2.7-9.9,2.7-9.9s8.3-2.1,11.2-7.5s2.4-11,0.8-16.6c-1.6-5.6-9.9-21.9-15.5-31c-5.6-9.1-17.4-14.2-23-15.8 C628,242.3,618.8,242.1,615.1,242.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M619.8,264.6c2.2-0.7,9.2-6.9,11.9-13.1c1.1-2.4,1.8-4.9,2.2-7.4l-0.4-0.1c-5.6-1.6-14.7-1.9-18.4-1.9 c0,0-3.3,1.1-7.5,2.7c0,3.3,0.6,6.6,1.8,9.7C611.9,260.7,617.7,265.4,619.8,264.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M645.3,277.2c0,0,6.4,34.3,13.7,37.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M583.8,310.6c0,0,8-30.3,8.6-33.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M655.7,292.7c0,0-4.4,1-4.4,4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M580.2,293.1c0,0,5,3.2,4.5,8.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M613.4,433c2.5,0,6.8-2.2,7.8-2.7c1,0.5,5.3,2.7,7.8,2.7c2.8,0,12.1,1.2,16.5,1.2c4.4,0,7.7-1.2,3.2-4 c-3.8-2.4-11.9-8.2-14-9.7c-4.7,4.3-14.1,3.3-14.1,3.3c-1.9-0.3-3.8-0.7-5.6-1.2c-2.8-0.8-6.8-2.4-6.8-2.4s-10,7.2-14.5,10 s-1.2,4,3.2,4C601.3,434.3,610.6,433,613.4,433z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 620.6,
    y1: 420.3,
    x2: 620.6,
    y2: 350.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "621.2,430.3 620.6,423.7 620.6,420.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 615,
    y1: 347.8,
    x2: 626.6,
    y2: 347.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M599.8,201.9c0,0-8.3,5-7.1,9.4s5,5.2,4.2,7.7c-0.8,2.4-3.7,4-0.4,5.5c1.9,0.8,3.8,1.5,5.9,1.9 c0,0,3.1,10.6,8.3,12.5c5.3,1.9,14.4,0.6,20.9-0.2c4.5-0.4,8.2-3.6,9.4-7.9c0.6-2.3-2.7,0.4-4.4-2.1s0.8-9,2.7-14.6 c1.9-5.6-3.8-16.3-11.1-19.8C620.9,190.7,606.9,192.5,599.8,201.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M613.8,238.3c-1.1,3.5-1.8,7.1-2.1,10.7c-0.3,4.6,3.5,9.6,7.5,9.4s7.5-8.3,8-12.3s-1.3-14.7-1.3-14.7 s-6.1,0.3-8.6,2.4C615.8,235.1,614.6,236.6,613.8,238.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M608.3,207.8c0,0,0.2,6.3,6.5,12.3c3.8,3.6,8.2,6.5,13.1,8.4c-0.1,1.4-0.5,2.7-1,4c-0.6,1.1-1.7,1.7-2.9,1.5 h-2.1c0,0-3.1,7.2-6.8,8.2s-12.8,0.3-14.1-8.9s-1.5-16.7-0.4-18.6C601.6,212.8,608.3,207.8,608.3,207.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M673.9,288.6c1-1.9,1.5-4,1.7-6.1c0-2.8-5.2-6.8-6.1-7.8s-1.9-0.9-2.1,0.5c0,1.6,0.6,3.1,1.8,4.2 c0.8,0.6,1.3,1.5,1.6,2.4c0.1,0.7-1.7,4.1-0.8,6.3C670.9,290.2,673.5,290.9,673.9,288.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M466.3,272.9c0,0,22.6,7.2,36.1,24.1c13.6,16.9,22.5,14.4,39.4,8.8c16.9-5.6,23.3-25.7,46.6-8.8 c23.3,16.9,28.1,23.3,47.4,13.6c19.3-9.6,29.7-32.9,47.4-24.9c17.7,8,9.6,49.1,11.2,69s-0.8,69.9,3.2,76.3c4,6.4,45,1.5,45,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M508.5,246.1c0,0-4.5-7.3-11.1-5.4c-7,2-10.6,12-12.3,18.3c-1.6,6.2-2.7,13-5.8,18.8c0,0-13.3-0.2-20.7-2.4 c-5.7-1.8-11.2-3.8-16.7-6.1c0,0-2.6-3.7-4.5-4.4s-6.7-2.1-7-1c-0.4,1.1,5.6,4.7,5.6,4.7s-11,1.5-12.1,2.7s7.8,4.7,7.8,4.7 s3.3,1.1,11.4-0.9c0,0,29.7,18.9,35.6,21s9.2,2.9,13.2-4.9s17.4-27.1,19.6-34.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M449.8,272.4c-4.3-1.6-7.7-3.1-7.7-3.1s-2.6-3.7-4.5-4.4c-1.9-0.7-6.7-2.1-7-1c-0.4,1.1,5.6,4.7,5.6,4.7 s-11,1.5-12.1,2.7s7.8,4.7,7.8,4.7s3.3,1.1,11.4-0.9l4.2,2.6L449.8,272.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M564.3,291.4c-1-1.9-1.5-4-1.7-6.1c0-2.8,5.2-6.8,6.1-7.8c0.9-1,1.9-0.9,2.1,0.5c0,1.6-0.6,3.1-1.8,4.2 c-0.8,0.6-1.3,1.5-1.6,2.4c-0.1,0.7,1.7,4.1,0.8,6.3C567.3,293.1,564.8,293.7,564.3,291.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M567.8,283c0,0-4.3,7.9-1.8,10.7c2.5,2.8,4.9-6.4,5.4-8.9C571.9,282.3,569.4,279.7,567.8,283z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M571.4,285.8c0,0-4.3,7.9-1.8,10.7c2.5,2.8,4.9-6.4,5.4-8.9C575.4,285.1,572.9,282.4,571.4,285.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M575.2,286.5c0,0-4.3,7.9-1.8,10.7c2.5,2.8,4.9-6.4,5.4-8.9C579.3,285.7,576.8,283.2,575.2,286.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M580.2,286.5c0,0-4,6.1-1.8,8.4s4.5-5,5-7.1C583.9,285.8,581.7,283.8,580.2,286.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M671.1,283.3c0,0,4.3,7.9,1.8,10.7c-2.5,2.8-4.9-6.4-5.4-8.9C667.1,282.5,669.5,280,671.1,283.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M667.6,286.1c0,0,4.3,7.9,1.8,10.7c-2.5,2.8-4.9-6.4-5.4-8.9C663.6,285.3,666,282.8,667.6,286.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M663.7,286.8c0,0,4.3,7.9,1.8,10.7c-2.5,2.8-4.9-6.4-5.3-8.9C659.7,286,662.1,283.5,663.7,286.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M658.7,286.9c0,0,4,6.2,1.8,8.4c-2.2,2.2-4.5-5-5-7.1C655.1,286.1,657.2,284.1,658.7,286.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M131.1,374.2v8.7c-3,3.3-5.2,7.3-6.3,11.6c-1.9,7.1-7.7,37.7-6.1,38.5c1.5,0.8,16,4.1,20.6,3.4 c5.3-0.8,9.8-0.5,7.1-3.4c-2.7-2.9-16.6-11.1-16.6-11.1s15.3-22.2,18.7-30.4s4-20.9,4-20.9l-20.6-0.8L131.1,374.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M139.2,436.5c5.3-0.8,9.8-0.5,7.1-3.4c-2.7-2.9-16.6-11.1-16.6-11.1l-0.5,3.2l-10-1.2 c-0.7,5.1-1.1,8.9-0.5,9.2C120.3,433.9,134.6,437.2,139.2,436.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M181.5,378.7l2.4,4.2c-2,3.8-2.3,8.3-0.8,12.4c2.4,7.4,7.9,34.6,7.9,36.2s3.4,2.6,6.1,2.6 c2.7,0,10.2,0.5,11.3,0.5c1.1,0,8.7,1.3,11.3-0.3c2.6-1.6-3.4-4.8-7.3-6.6s-12.7-6.6-12.7-6.6s2.1-21.7,2.1-31.2s2.1-12.7-0.8-18.5 c-2.9-5.8-21.1,2.7-21.1,2.7L181.5,378.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M212.4,427.8c-4-1.9-12.7-6.6-12.7-6.6l-1.1,4l-8.5,1.5c0.5,2.6,0.8,4.4,0.8,4.8c0,1.5,3.4,2.6,6.1,2.6 s10.2,0.5,11.3,0.5c1.1,0,8.7,1.3,11.3-0.3C222.4,432.9,216.4,429.7,212.4,427.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M167.3,203c-2.1-3.5-4.4-6.9-7.1-10c-3.6-4.1-15-3.9-20,1.5c-5,5.4-3.4,15-1.5,17.8c1.9,2.7,5.7,15.5,5.7,15.5 l0.9,9.1l21.2,7.5l-4.3-14.8c0,0,8.2-1.5,8.9-4.1c0.7-2.6-1.4-11.2-1.4-11.2s2.7-1.8,2.5-3.4C171.9,209.3,167.3,203,167.3,203z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M142.9,212.8c0,0,3.6,3.1,5.6-0.4c2-3.5,3.5-6.9,3.5-9.9c0-3-7.4-5.4-2.5-7.4c5-2,8.5,2.4,10.7-2 c2.2-4.4,0.2-4.9-11.7-4.9s-17.9,6-15.3,13.4c2,5.5,4.5,10.8,7.4,15.9L142.9,212.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M168,208.3c0,3.1-2.5,5.7-5.7,5.7s-5.7-2.5-5.7-5.7c0-3.1,2.5-5.7,5.7-5.7C165.4,202.6,168,205.1,168,208.3 L168,208.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M167.1,203.2c0.7-0.3,1.4-0.4,2.1-0.4c3,0,5.3,2.4,5.3,5.4c0,1.9-1.1,3.7-2.8,4.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 156.6,
    y1: 208.3,
    x2: 142.9,
    y2: 212.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M146.8,215.8c0,0-2.7-5.7-5.5-4.6c-2.7,1.1-1.4,10,1.4,10.9c1.9,0.4,3.8-0.1,5.2-1.4c0,0,2.3,4.8,5,6.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M128.9,318l-1.7,21.8l-5.1,32.3c0,0,11.9,9.3,23,9.3s14.2-1.4,14.2-1.4l6.2-33.1l6.2,34.8c0,0,12.3-2,20.4-4 c5.7-1.6,11-4.1,15.9-7.4l-16.4-42.8l-3.6-22.1c0,0-18.4,1.7-29.5,2.3c-11.1,0.6-25.8-2.3-25.8-2.3L128.9,318z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M140.6,230.9c0,0,26.1,9.1,34.1,17.9c4.4,4.9,9.4,38.5,11.2,46.7c1.8,8.2,4.9,24.5,4.9,24.5 s-15.9,7.2-28.2,7.4c-12.3,0.3-35.9-5.4-35.9-5.4s2.8-36.4,2.8-53.3s0.3-28,3.1-33.3C132.7,235.5,137.3,230.4,140.6,230.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M133.8,324.7c0,0,1.4,23.8,0,32.6c-1,5.7-2.7,11.2-5.1,16.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M134.3,336.1c4.3-1.5,7.6-5.1,8.5-9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M123.6,367.5c0,0,14.2,12.2,36.3,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M171.1,374.6c0,0,23.2-2.5,33.4-9.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M275,219.9c0,0-2.2,1.7-10,7.4s-1.7,14.3-1.7,14.3s-5.6,0.9-13,8.7c-7.5,7.8,3.3,21.3,13.4,23.4 s21.9-10.4,25.4-21.9c3.5-11.6-1.1-29-3.5-32.6C283.2,215.5,275,219.9,275,219.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M304.6,218.3c0,0,3.9-6,0.4-14.7c-3.5-8.7-14-12.7-24.2-6.4c-7,4.2-10.3,12.5-8.1,20.4c1,4,6,10.2,7.1,10.3 c1.1,0.1,10.2,3.4,16.5,0.5C302.5,225.5,304.6,218.3,304.6,218.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M259.4,420.8c0,0,7.3,11.3,19.9,13.3c12.7,1.9,1.3-9.4-0.9-11.1C276.4,421.2,261.1,417.5,259.4,420.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M326.8,423.7c0,0,13.9,3.4,12.8,6.4s-12.4,2.8-19,1.1c-6.6-1.7-12.9-4.3-12-7.1 C309.5,421.3,326.8,423.7,326.8,423.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M287.3,240.9c0,0-18.6,2.7-22,9.3c-3.4,6.6,1.4,42.4,1.4,42.4s-7.9,17.5-8.1,28.8c-0.1,11.3,4.9,31.1,4.5,36.1 c-0.4,5-5.5,61.3-5.5,62.9c0,1.5,10.7,5,26.2,6.8c15.5,1.8,45.1-3.7,45.1-3.7s-0.6-33.3,1-53.1c1.5-19.8-0.7-37.7-4.6-45.1 c-3.9-7.4-22.3-34.1-22.3-34.1s8.9-16.1,9.4-23.2c0.6-7.1-2.3-10.7-9-18.8C299.4,244.4,293.6,241.4,287.3,240.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M303,291.3c0,0,8.9-16.1,9.4-23.2c0.6-7.1-2.3-10.7-9-18.8c-0.3-0.4-0.7-0.8-1-1.1l-0.2,0.2 c-6.9,11.3-29.7,30.5-36.5,36.1c0.5,4.8,1,8.1,1,8.1s-7.9,17.5-8.1,28.8c0.1,5.1,0.6,10.3,1.5,15.3c16.1-9.2,37.7-26.4,49.3-36 C305.8,295.3,303,291.3,303,291.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M283.8,227.7c0.5,4.2,0.8,8.4,0.8,12.7c-0.2,3.1,0.8,10.3,6.1,12.6c5.4,2.3,8.7-0.9,8.7-4 c-0.2-2.6-0.7-5.2-1.5-7.7l0.2-8.7C298.2,232.6,288.9,226.8,283.8,227.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M279,222.1c0,0-3.9-3.5-4.1,1.5c-0.1,5,4.5,6.7,5.5,7c0.9,0.1,1.7-0.1,2.4-0.6c0,0,7.1,6.1,12.9,6.5 c5.7,0.4,8.1-2.3,9.4-12.7c1.3-10.4-9.4-21-9.4-21S286.6,219.9,279,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M191.3,319.8c-0.1-1.8,0.2-3.5,0.9-5.2c1-2.1,6.1-3.3,7.3-3.7s1.7,0,1.4,1.1c-0.5,1.2-1.5,2.1-2.8,2.5 c-0.8,0.2-1.5,0.6-2,1.2c-0.3,0.5-0.1,3.6-1.5,5C193.1,322.1,190.8,321.7,191.3,319.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M308.9,273.7c0,0-18.4-2.4-26.5,10.4c-8.1,12.9-23.3,57.8-51.4,65.1s-36.1-50.6-53-49 c-16.1,1.5-27.3,0-36.9,17.7c-5.2,9.5-30.9,112.8-43.1,113.8c-38.8,3.4-63.7,1.2-63.7,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M141.8,231.6c0,0-4.2-1.7-9.9,1.7s-20.9,40.5-19.8,44.5c1.1,4,17.3,11.3,26.3,13.9c9.1,2.5,25.5,5.7,25.5,5.7 s5.1,7.9,6.8,8.2c2.5,0,4.9-0.3,7.4-0.8c0,0,3.1,2.5,4.2-0.3c1.2-2.8-1.1-6.5-3.7-9.3c-2.5-2.8-13.3-4.2-13.3-4.2l-29.2-20.1 l12.3-22.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M170.7,305.5c2.5,0,4.9-0.3,7.4-0.8c0,0,3.1,2.5,4.2-0.3c1.2-2.8-1.1-6.5-3.7-9.3c-2.5-2.8-13.3-4.2-13.3-4.2 l-29.2-20.1l4.4-8.1c-10.9-6.8-18.1-6.3-22.1-4.9c-3.9,9.4-6.9,18.3-6.4,20.1c1.1,4,17.3,11.3,26.3,13.9c9.1,2.5,25.5,5.7,25.5,5.7 S169,305.3,170.7,305.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M353.1,274.4c-1.2-13.4-7.7-24.4-15.3-28.8l-0.2-2.7l-20,1.9c-11.3,1-19,16.5-17.4,34.6 c1.7,18,12.2,31.8,23.4,30.7l20-1.9l-0.3-2.7C350.1,299.7,354.3,287.7,353.1,274.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M362.2,273.6c-1.3-14.1-7.7-25.6-15.8-30.2l-0.3-2.9l-8.6,0.8c-11.8,1.1-20,17.3-18.3,36.3 c1.7,19,12.8,33.4,24.6,32.3l8.6-0.8l-0.3-2.9C359.3,300.1,363.5,287.6,362.2,273.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M370.7,272.7c1.8,19-6.4,35.2-18.3,36.3c-11.9,1.1-22.9-13.4-24.7-32.3c-1.8-18.9,6.4-35.3,18.2-36.3 S369,253.8,370.7,272.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M380,261.6l-33.3,3.1c-2,0.2-3.7-1.2-3.9-3.2c0,0,0,0,0,0l0,0c-0.2-2,1.2-3.7,3.2-3.9c0,0,0,0,0,0l33.3-3.1 c2-0.2,3.7,1.2,3.9,3.2c0,0,0,0,0,0l0,0C383.4,259.7,381.9,261.5,380,261.6C380,261.6,380,261.6,380,261.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M382.4,288l-33.3,3.1c-2,0.2-3.7-1.2-3.9-3.2c0,0,0,0,0,0l0,0c-0.2-2,1.2-3.7,3.2-3.9c0,0,0,0,0,0l33.3-3.1 c2-0.2,3.7,1.3,3.9,3.2l0,0C385.8,286.1,384.4,287.8,382.4,288C382.4,288,382.4,288,382.4,288z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M275.8,243.4c0,0-8,1.5-11.8,6.1c-3.8,4.6-11.6,40.1-9.8,44.2s30.5,9.2,39.4,9.9c7.1,0.3,14.3,0,21.4-1 c0,0,7.7-0.2,9.8-0.6c2.1-0.4,6-2.4,6-3.2c0.1-0.8-0.3-2.7-3.2-2.9c-2.9-0.2-9-2.3-9.8-2.3c1.8-0.5,3.7-0.9,5.6-1.1 c0,0,0.4-1.5-2.8-1.5s-6-0.2-7.2,1.5c-0.9,1.4-1.6,2.8-2.2,4.3c0,0-17.7,1.2-27.3-3.5c-9.6-4.7-12.7-6.3-12.7-6.3l6.9-27.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M324.7,302.2c2.1-0.4,6-2.4,6-3.2c0.1-0.8-0.3-2.7-3.2-2.9c-2.9-0.2-9-2.3-9.8-2.3c1.8-0.5,3.7-0.9,5.6-1.1 c0,0,0.4-1.5-2.8-1.5s-6-0.2-7.2,1.5c-0.9,1.4-1.6,2.8-2.2,4.3c0,0-17.7,1.2-27.3-3.5c-9.6-4.7-12.7-6.3-12.7-6.3l4.2-16.9 c-5.5-2.3-11.2-3.7-17.1-4.2c-2.9,11.6-5.2,25.2-4.1,27.6c1.8,4.1,30.5,9.2,39.4,9.9c7.1,0.3,14.3,0,21.4-1 C315,302.7,322.7,302.5,324.7,302.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M195.2,316.9c0,0-5.9,4.4-5,7.4s5.8-3.1,7.1-4.8S197.5,315,195.2,316.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M196.4,320.8c0,0-5.9,4.4-5,7.4c0.9,2.9,5.9-3.1,7.1-4.8S198.7,318.9,196.4,320.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M199.2,323.4c0,0-5.9,4.4-5,7.4c0.9,2.9,5.8-3.1,7.1-4.8C202.5,324.2,201.5,321.5,199.2,323.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M201.5,325.5c0,0-5.1,3.3-4.2,5.7c0.9,2.4,5.1-2.2,6.1-3.6C204.5,326.2,203.6,324,201.5,325.5z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingFields);
export default __webpack_public_path__ + "static/media/missing_fields.122bf8979139662fd9d1ff7dbfe00b2e.svg";
export { ForwardRef as ReactComponent };